import { render } from "./RoleTable.vue?vue&type=template&id=6aa12ca0&scoped=true"
import script from "./RoleTable.vue?vue&type=script&lang=js"
export * from "./RoleTable.vue?vue&type=script&lang=js"

import "./RoleTable.vue?vue&type=style&index=0&id=6aa12ca0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa12ca0"]])

export default __exports__